interface WidgetCardProps {
  title: string
  value?: number
  conversionRate?: number
}

export const WidgetCard = ({ title, value, conversionRate }: WidgetCardProps) => {
  return (
    <div className='flex flex-col justify-start gap-1 p-3 rounded-3xl border border-[text-muted-foreground]'>
      <div className='text-sm text-muted-foreground font-semibold'>{title}</div>
      <div className='flex items-end gap-1'>
        <div className='text-2xl font-semibold'>{value ?? 'N/A'}</div>
        {conversionRate && (
          <div className='flex items-end gap-1'>
            <div className='text-3xl font-semibold'>/</div>
            <div className='flex flex-col'>
              <div className='text-xs font-semibold'>{conversionRate}%</div>
              <div className='text-xs font-semibold text-muted-foreground'>conv. rate</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
